export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.lemon_admin_dashboard_language;
  },
  // END:: GET APP LOCALE
};
